export const STRINGS = {
  // Leading dot so the suffix reads as "<subdomain>.reachiq.ai" in the field.
  DOMAIN_LABEL: ".reachiq.ai",
};
